/* eslint-disable @typescript-eslint/naming-convention */
export enum OrderStatus {
    Unpaid = 'UNPAID',
    OnHold = 'ON_HOLD',
    AwaitingShipment = 'AWAITING_SHIPMENT',
    AwaitingCollection = 'AWAITING_COLLECTION',
    InTransit = 'IN_TRANSIT',
    Delivered = 'DELIVERED',
    Completed = 'COMPLETED',
    Cancelled = 'CANCELLED',
}
